import React from "react";
import PropTypes from "prop-types";

import { AccordionTab as PRAccordionTab } from "primereact/accordion";

import Div from "@components/Div";
import Icon from "@components/Icon";
import Tooltip from "@components/ToolTip";

import { GradeIconsData } from "./CaseDeviationsAccordion.constants";
import { StyledRichText, StyledAccordion, StyledIcon } from "./components";

const CaseDeviationsAccordionTooltip = ({ target = "", tooltip = "" }) => {
  const formattedTarget = target?.replace?.(/ /g, "-") ?? "";

  return (
    <>
      <Tooltip
        isHtml
        target={`.tooltip-icon-${formattedTarget}`}
        content={tooltip}
      />

      <Icon
        name="info"
        className={`tooltip-icon-${formattedTarget}`}
        bg="var(--turquoise)"
        color="var(--white)"
        borderRadius="50%"
        fontSize="var(--fs-text-m)"
        p="2px"
      />
    </>
  );
};

CaseDeviationsAccordionTooltip.propTypes = {
  target: PropTypes.string,
  tooltip: PropTypes.string,
};

const CaseDeviationsAccordionHeader = ({
  title = "",
  grade,
  iconColor,
  tooltip = "",
}) => {
  const iconProps = iconColor && {
    bg: `var(--${iconColor}) !important`,
    border: `solid var(--${iconColor}) !important`,
  };
  const isTooltipVisible = tooltip && tooltip !== "";

  return (
    <Div className="p-accordion-header-template">
      <Div className="p-accordion-header-text">
        {title}

        {isTooltipVisible && (
          <CaseDeviationsAccordionTooltip target={title} tooltip={tooltip} />
        )}
      </Div>

      {grade !== null && grade !== undefined && (
        <Div className="p-accordion-value-icon">
          <StyledIcon key={grade} {...GradeIconsData[grade]} {...iconProps} />
        </Div>
      )}
    </Div>
  );
};

CaseDeviationsAccordionHeader.propTypes = {
  title: PropTypes.string,
  grade: PropTypes.string,
  iconColor: PropTypes.string,
  tooltip: PropTypes.string,
};

const CaseDeviationsAccordion = ({
  content = [],
  activeIndex,
  onTabChange,
}) => {
  const renderContent = ({ htmlContent = "" }) => (
    <StyledRichText fontWeight="var(--regular-weight)">
      {htmlContent}
    </StyledRichText>
  );

  return (
    <StyledAccordion
      multiple
      activeIndex={activeIndex}
      onTabChange={onTabChange}
    >
      {content?.map((item, index) => (
        <PRAccordionTab
          key={`${index}_${item?.title}`}
          headerTemplate={<CaseDeviationsAccordionHeader {...item} />}
        >
          {item?.content ?? renderContent(item)}
        </PRAccordionTab>
      ))}
    </StyledAccordion>
  );
};

CaseDeviationsAccordion.propTypes = {
  content: PropTypes.array,
  activeIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  onTabChange: PropTypes.func,
};

export default CaseDeviationsAccordion;
